import { Component, OnInit, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpHelpUtils } from './../../utils/HttpHelpUtils';
import { MessageSub } from './../../utils/MessageSub';
import { OssFileService } from './../../components/oss-file/oss-file.service';
import { RegExUtils } from '../../utils/RegExUtils';

import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { PDetailSidebarModule } from './../../components/p-detail-sidebar/p-detail-sidebar.component';
import { BaseCommpont } from 'src/app/utils/BaseCommpont';
import { SkeletonModule } from 'primeng/skeleton';
import { ImagePreviewService } from './../../components/image-viewer/image-preview.service';
import { DriverDetailModule } from './../../components/driver-detail/driver-detail.component';

import { ChartModule } from 'primeng/chart';
import { KnobModule } from 'primeng/knob';

import { AccordionModule } from 'primeng/accordion';
import { ChipModule } from 'primeng/chip';
import { DomSanitizer } from '@angular/platform-browser';
import {DialogModule} from 'primeng/dialog';

@Component({
    selector: 'app-truck-detail',
    templateUrl: './truck-detail.component.html',
    styleUrls: ['./truck-detail.component.scss']
})
export class TruckDetailComponent implements OnInit {
    credentials: string;                                                        // radiobutton:ngmodel
    regExUtils = new RegExUtils();                                  // 校验规则

    stateOptions = []
    value1: string = "off";
    truckId = '';
    @Input() truckDetail: {} = {};                                              // 运单输入详情
    @Output() onClose: EventEmitter<any> = new EventEmitter();                  // 关闭弹窗
    @Input() percentWidth = 80;                                                 // 宽度比例，默认是80%；
    localTruckDetail = {};                                                      // 运单详情
    bc = new BaseCommpont();
    businessCertificatePhoto = '';//经营许可证照片
    businessLicensePhoto = '';//营业执照照片照片
    vehicleLicensePhoto = '';//行驶证主页
    vehicleLicenseBackPhoto = ''//行驶证副页
    optCertPhoto = '';//道路运输证
    vehicleLicenseCheckPhoto = ''; // 行驶证年审页
    affiliationAgreementPhoto = ''; // 挂靠协议
    plateColorMap = {}; //车牌颜色
    energyTypeMap = {};//车辆能源类型
    isPersonalMap = {};//车辆属性
    vehicleTypeMap = {};//车辆类型
    relAgentList = [];//代理商
    relCusList = [];//货主
    relDriverList = [];//关联司机
    relTeamList = [];//关联车主
    truckModelLists = [];//车型
    truckSizeLists = [];//车辆尺寸
    truckModelMap = {};//车型
    truckSizeMap = {};//车长
    // 车型枚举映射（addTruckType 值到 数字-文字 格式）
    addTruckTypeMap: { [key: string]: string } = {
        '01': '01-卡车',
        '02': '02-厢式货车',
        '03': '03-封闭货车',
        '04': '04-平板货车',
        '05': '05-自卸货车',
        '06': '06-特殊结构货车',
        '07': '07-油罐车',
        '08': '08-汽罐车',
        '09': '09-液罐车',
        '10': '10-冷藏车',
        '11': '11-拖拉机',
        '12': '12-集装箱',
        '13': '13-半挂牵引车',
        '14': '14-栅栏式货车',
        '15': '15-重型普通货车',
    };


  driverDetail = [];                                                // 司机详情
  showDriverFlag = false;                                           // 显示司机详情


    loadingTruckInfo = false;
    loadingRelInfo = false;
    endDateColor = '#4ea844';
    totalNum = 0;//累计发运量
    totalWeight = 0;//累计运输吨数
    totalKilometre = 0;//累计行驶公里数
    ringRatioNum = 0;//发运量-环比
    ringRatioWeight = 0;//运输吨数 - 环比
    departPhotos  = [];                                                  //协议图片

    myTruck = {
        plateNumber: '',                                              // 车牌号
        showTeamDetailFlag: false,                                    // 显示车主详情
        truckDetailHeader: '',                                         // 设置车辆标题
        saveTruckUrl: '',                                              // 保存编辑车辆数据
        uploadTruckName: 'vehLicUploadfile',                           // 上传标识
        tempTruckId: '',                                               // 临时车辆id
        vehicle_license_photo_url: '',                                 // 行驶证照片
        business_certificate_photo_url: '',                            // 经营许可证
        agreement_photo_url: '',                                    // 挂靠协议照片
        TeamTruckPhotoFlag: false,                                   // 上传挂靠协议照标识
        TeamTruckPhotoPicFlag: false,                                   // 挂靠协议照标识

        truckPicDetailHeader: '',                                         // 设置挂机协议图片标题

        departUploadFileList : [],                                                 // 挂靠协议图片列表

        teamDetail: [],                                               // 车主详情
        myTruckListDialogFlag: false,                                  // 我的车辆设置
        trucksDataList: [],                                            // 车辆列表
        selectedTruckList: [],                                         // 选中的车辆数据
        truckEditDialogFlag: false,                                    // 新增车辆基本信息
        truckCheckDialogFlag: false,                                   // 校验车牌号
        uploadTruckPhotoUrl: '',                                       // 上传人车照地址
        checkTeamTruckDialogFlag: false,
      }

    useStatus = {                                                     // 使用状态
        0: '空闲',
        1: '工作中'
    };
    isOnlineMap = {
        1: '查不到入网',
        2: '未入网',
        3: '已入网'
    };
    checkFlag = {                                                     // 审核状态
        0: "待提交",
        1: "待审核",
        2: "已审核",
        3: "审核不过"
    };

      //签署状态,0:待签署，1：签署中，2：签署完成，3：签署失败
      signStatus = {
        0:'待签署',
        1:'签署中',
        2:'已签署',
        3:'签署失败'
    }
    constructor(
        private httpHelp: HttpHelpUtils,
        private fb: FormBuilder,
        private messageSub: MessageSub,
        private ossFileService: OssFileService,
        private imagePreviewService: ImagePreviewService,
        private sanitizer : DomSanitizer

    ) {
        this.stateOptions = [{ label: '未通过', value: 'off' }, { label: '通过', value: 'on' }];
    }

    // 切换tab
    tabList = ["车辆数据", "影像资料"]
    // 切换tab
    activeIndex = 0;
    handleTabClick(i) {
        this.activeIndex = i;
    }
    imgPriview: '';                                                               // 展示图
    thumbnailImageSrc = [];                                                       // 缩略图
    current = 0;                                                                  // 旋转角度
    chartData: any;                                                               // 柱状图数据
    chartOptions: any;
    // 向左旋转
    handleTurnLeft() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current - 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 向右旋转
    handleTurnright() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current + 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 预览图切换
    previewImgIndex = 0                                                                           // 小图下标
    afiles = [];
    imgDescribe = '';
    handlePreviewImgClick(item, i) {
        this.imgPriview = item.url;
        this.imgDescribe = item.title;
        this.previewImgIndex = i;
        this.current = 0
        this.afiles.push(this.imgPriview)
    }


    closeDetail() {
        this.onClose.emit();
    }


     // 显示司机详情
     showDriverDetail(item) {
       console.log(item);
      item.driverId = item.id;
      this.driverDetail = item;
      this.showDriverFlag = true;
  }
    // 预览图片接口
    async viewOSSFile(folder, imgName) {
        const that = this;
        let result = {};
        return new Promise((resolve, reject) => {
            that.httpHelp.get('psg/common/view-img', {
                folder: folder,
                imgName: imgName
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    }
//查看法大大协议
showFadadaDriverFlag = false;//弹框开关
agreeHeaderTitle = '';//标题
safeUrl;//协议链接地址
showFadadaDriverAgree(res){
    console.log(res);
    if (res['contractNo']) {
        this.agreeHeaderTitle = '委托代开协议（' + res['realname'] + '）';
        this.httpHelp.loadingBlock = true;
        this.httpHelp.get('psg/drivers/get-driver-fadada', { contractNo: res['contractNo'] }).then(res => {
            this.httpHelp.loadingBlock = false;
            if (res['status'] == this.bc.svrType && res['data']) {
                this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res['data']['signUrl']);
                this.showFadadaDriverFlag = true;
            } else {
                this.bc.showMessage(this.messageSub, '获取法大大协议失败：' + res['message'], 'error');
            }
        });
    }
}



    //初始化代码表字典
    dicInit() {
        this.httpHelp.loadingBlock = true;
        this.httpHelp.get('psg/diction/dicType',
            { dicTypes: 'vehicle_classification_code,plate_color,energy_type,is_personal,truck_length,truck_type' }).then(res => {
                this.httpHelp.loadingBlock = false;
                if (res['status'] == 'success') {
                    this.vehicleTypeMap = {};
                    this.plateColorMap = {};
                    this.energyTypeMap = {};
                    this.isPersonalMap = {};
                    const tempGoodsTypeList = res['data'];
                    tempGoodsTypeList.forEach(e => {
                        //车辆类型
                        if (e['dicType'] == 'vehicle_classification_code') {
                            this.vehicleTypeMap[e['value']] = e['text'];
                        }
                        //车牌颜色
                        if (e['dicType'] == 'plate_color') {
                            this.plateColorMap[e['value']] = e['text'];
                        }
                        //车辆能源类型
                        if (e['dicType'] == 'energy_type') {
                            this.energyTypeMap[e['value']] = e['text'];
                        }
                        //车辆属性
                        if (e['dicType'] == 'is_personal') {
                            this.isPersonalMap[e['value']] = e['text'];
                        }
                        //车长
                        if (e['dicType'] == 'truck_length') {
                            this.truckSizeMap[e['value']] = e['text'];
                        }
                        //车型
                        if (e['dicType'] == 'truck_type') {
                            this.truckModelMap[e['value']] = e['text'];
                        }
                    })
                } else {

                }
            });
    }

    ngOnInit(): void {
        this.dicInit();
        this.chartOptions = {
            // title: {
            //     display: true,
            //     text: '车辆数据',
            //     fontSize: 16
            // },
            legend: {
                position: 'top'
            }, scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };
        this.loadingTruckInfo = true;
        this.httpHelp.get('psg/trucks/get-plateNumber-list', { truckId: this.truckDetail['truckId'] }).then(res => {
            this.loadingTruckInfo = false;
            if (res['status'] == this.bc.svrType) {
                if (res['data']) {
                    //参数数据
                    console.log("erere",res)
                    this.localTruckDetail = JSON.parse(JSON.stringify(res['data']));
                  
                    this.localTruckDetail['expiredWarnDay'] = this.truckDetail['expiredWarnDay'];
                    
                    // 补充缺失的字段 - 从truckDetail中获取
                    // 注意：0 值表示没有数据，不需要补充
                    if ((!this.localTruckDetail['addTruckType'] || this.localTruckDetail['addTruckType'] === 0) 
                        && this.truckDetail['addTruckType'] && this.truckDetail['addTruckType'] !== 0) {
                        this.localTruckDetail['addTruckType'] = this.truckDetail['addTruckType'];
                    }
                    if ((!this.localTruckDetail['truckSize'] || this.localTruckDetail['truckSize'] === 0) 
                        && this.truckDetail['truckSize'] && this.truckDetail['truckSize'] !== 0) {
                        this.localTruckDetail['truckSize'] = this.truckDetail['truckSize'];
                    }
                    if ((!this.localTruckDetail['seats'] || this.localTruckDetail['seats'] === 0) 
                        && this.truckDetail['seats'] && this.truckDetail['seats'] !== 0) {
                        this.localTruckDetail['seats'] = this.truckDetail['seats'];
                    }
                    if ((!this.localTruckDetail['axleCount'] || this.localTruckDetail['axleCount'] === 0) 
                        && this.truckDetail['axleCount'] && this.truckDetail['axleCount'] !== 0) {
                        this.localTruckDetail['axleCount'] = this.truckDetail['axleCount'];
                    }
                    // 车型字段：使用 truckType 而不是 addTruckType
                    if ((!this.localTruckDetail['truckType'] || this.localTruckDetail['truckType'] === 0) 
                        && this.truckDetail['truckType'] && this.truckDetail['truckType'] !== 0) {
                        this.localTruckDetail['truckType'] = this.truckDetail['truckType'];
                    }
                    if (this.localTruckDetail['endUseDate'] != '' && this.localTruckDetail['endUseDate'] != null) {
                        var date = new Date();
                        var now = date.valueOf();
                        var time = new Date(this.localTruckDetail['endUseDate']).valueOf();
                        if (now > time) {
                            this.endDateColor = 'red';
                        } else {
                            this.endDateColor = '#4ea844';
                        }
                    }
                    // 行驶证主页
                    if (this.localTruckDetail['vehicleLicensePhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['vehicleLicensePhoto']).then(res1 => {
                            if (res['status'] == this.bc.svrType) {
                                this.vehicleLicensePhoto = res1['data']['url'];
                                let obj = { 'url': this.vehicleLicensePhoto, 'title': '行驶证主页' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }
                    // 行驶证副页
                    if (this.localTruckDetail['vehicleLicenseBackPhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['vehicleLicenseBackPhoto']).then(res1 => {
                            if (res['status'] == this.bc.svrType) {
                                this.vehicleLicenseBackPhoto = res1['data']['url'];
                                let obj = { 'url': this.vehicleLicenseBackPhoto, 'title': '行驶证副页' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }
                    //道路运输证
                    if (this.localTruckDetail['optCertPhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['optCertPhoto']).then(res2 => {
                            if (res['status'] == this.bc.svrType) {
                                this.optCertPhoto = res2['data']['url']
                                let obj = { 'url': this.optCertPhoto, 'title': '道路运输证' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }
                    // 年审页面
                    if (this.localTruckDetail['vehicleLicenseCheckPhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['vehicleLicenseCheckPhoto']).then(res2 => {
                            if (res['status'] == this.bc.svrType) {
                                this.vehicleLicenseCheckPhoto = res2['data']['url']
                                let obj = { 'url': this.vehicleLicenseCheckPhoto, 'title': '行驶证年审页' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }
                    // 经营许可证
                    if (this.localTruckDetail['businessCertificatePhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['businessCertificatePhoto']).then(res2 => {
                            if (res['status'] == this.bc.svrType) {
                                this.businessCertificatePhoto = res2['data']['url']
                                let obj = { 'url': this.businessCertificatePhoto, 'title': '经营许可证' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }


                     // 营业执照页面
                     if (this.localTruckDetail['businessLicensePhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['businessLicensePhoto']).then(res2 => {
                            if (res['status'] == this.bc.svrType) {
                                this.businessLicensePhoto = res2['data']['url']
                                let obj = { 'url': this.businessLicensePhoto, 'title': '营业执照' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }
                   

                    // 挂靠协议
                    if (this.localTruckDetail['affiliationAgreementPhoto']) {
                        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, this.localTruckDetail['affiliationAgreementPhoto']).then(res2 => {
                            if (res['status'] == this.bc.svrType) {
                                this.affiliationAgreementPhoto = res2['data']['url']
                                let obj = { 'url': this.affiliationAgreementPhoto, 'title': '挂靠协议' };
                                this.thumbnailImageSrc.push(obj);
                                if (this.thumbnailImageSrc.length > 0) {
                                    this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                                }
                            }
                        })
                    }
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载基础数据异常：' + res['message'], 'error');
            }
        });
        //加载关联数据
        this.loadingRelInfo = true;
        this.httpHelp.get('psg/trucks/get-truck-rel-detail', { truckId: this.truckDetail['truckId'] }).then(res => {
            this.loadingRelInfo = false;
            if (res['status'] == this.bc.svrType) {
                if (res['data']) {
                    this.relDriverList = res['data']['relDriverList'];
                    this.relTeamList = res['data']['relTeamList'];
                    //console.log( this.relTeamList);
                    //加载代理商
                    // if (res['data']['relAgentList'].length > 0) {
                    //     let agentIds = '';
                    //     let relAgentListTmp = res['data']['relAgentList'];
                    //     relAgentListTmp.forEach(item => {
                    //         agentIds += item.agentId + ',';
                    //     });
                    //     this.httpHelp.get('sys/agent/query-rel-agent', { ids: agentIds }).then(res => {
                    //         if (res['status'] == 'success') {
                    //             this.relAgentList = res['data'];//关联代理商信息
                    //         } else {
                    //         }
                    //     });
                    // }
                    // //关联货主信息
                    // if (res['data']['relCusList'].length > 0) {
                    //     let custIds = '';
                    //     let relCusListTmp = res['data']['relCusList'];
                    //     relCusListTmp.forEach(item => {
                    //         custIds += item.shipperId + ',';
                    //     });
                    //     //加载货主
                    //     this.httpHelp.get('sys/cust/query-rel-cust', { ids: custIds }).then(res => {
                    //         if (res['status'] == 'success') {
                    //             this.relCusList = res['data'];
                    //         } else {
                    //         }
                    //     });
                    // }
                }
            }
        });
        //加载图表数据
        this.httpHelp.get('psg/trucks/get-truck-total', { truckId: this.truckDetail['truckId'] }).then(res => {
            if (res['status'] == 'success') {
                let labels = [], money = [], number = [];
                const monthData: [] = res['data']['monthTotalList'];
                for (let i = 11; i >= 0; i--) {
                    const tempMonth = this.bc.setCreateTime(new Date().getTime() - (i * 720 * 3600 * 1000), 'yyyy-MM');
                    labels.push(tempMonth);
                    if (monthData && monthData.length > 0) {
                        let tempMoney = 0, tempNumber = 0;
                        a: for (var y = 0; y < monthData.length; y++) {
                            if (monthData[y]['dateMonth'] == tempMonth) {
                                tempMoney = monthData[y]['departWeight'];
                                tempNumber = monthData[y]['totalNumber'];
                                break a;
                            }
                        }
                        money.push(tempMoney);
                        number.push(tempNumber);
                    } else {
                        money.push(0);
                        number.push(0);
                    }
                }
                //图表加载
                this.chartData = {
                    labels: labels,
                    datasets: [{
                        type: 'line',
                        label: '发运吨数',
                        borderColor: '#42A5F5',
                        borderWidth: 2,
                        fill: false,
                        data: money
                    }, {
                        type: 'bar',
                        label: '发运量',
                        backgroundColor: '#FFF3DD',
                        data: number
                    }], scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                };
                this.totalNum = res['data']['totalNumber'];//累计发运量
                this.totalWeight = res['data']['departWeight'];//累计运输吨数
                this.totalKilometre = res['data']['totalKilometre'];//累计行驶公里数
                this.ringRatioNum = res['data']['ringRatioNum'];//发运量-环比
                this.ringRatioWeight = res['data']['ringRatioWeight'];//运输吨数-环比
            } else {
                this.bc.showMessage(this.messageSub, '加载用户数据异常：' + res['message'], 'error');
            }
        });
    }

    // 查看司机人车照
    checkDriverTruckPhoto(data) {
        if (!data || !data['driverTruckPhoto']) {
            this.bc.showMessage(this.messageSub, '未找到人车照片信息', 'error');
            return;
        }
        
        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, data['driverTruckPhoto'], 2).then(res => {
            if (res['status'] == this.bc.svrType) {
                if (res['data'] && res['data']['url']) {
                    this.imagePreviewService.preview([
                        res['data']['url']
                    ]);
                } else {
                    this.bc.showMessage(this.messageSub, '获取照片失败：未找到图片地址', 'error');
                }
            } else {
                this.bc.showMessage(this.messageSub, '获取照片失败：' + res['message'], 'error');
            }
        }).catch(err => {
            console.error('查看人车照失败:', err);
            this.bc.showMessage(this.messageSub, '查看人车照失败', 'error');
        });
    }

    //查看车主协议
    checkTeamAgreePhoto(data){
        this.ossFileService.viewOSSFile(this.regExUtils.TEAM, data['agreementPhoto']).then(res => {
            if (res['status'] == this.bc.svrType) {
                this.imagePreviewService.preview([
                    res['data']['url']
                ]);
            } else {
                this.bc.showMessage(this.messageSub, res['message'], 'error');
            }
        });


    }

      // 查看车主挂靠协议照
  checkTeamTruckPhoto(data) {

    const dPhotos: [] = data['agreementPhoto'].split(',');
    this.departPhotos=[];
    
    // 使用 Promise.all 等待所有图片加载完成
    const promises = dPhotos.map(e => {
      return this.ossFileService.viewOSSFile(this.regExUtils.AFFILIATION_AGREEMENT, e, 2).then(res => {
        if (res && res['data'] && res['data']['url']) {
          return res['data']['url'];
        }
        return null;
      }).catch(err => {
        console.error('加载图片失败:', err);
        return null;
      });
    });

    Promise.all(promises).then(urls => {
      this.departPhotos = urls.filter(url => url !== null);
      if (this.departPhotos.length > 0) {
        this.myTruck['TeamTruckPhotoPicFlag'] = true;
        this.myTruck['truckPicDetailHeader'] = '挂靠协议';
      } else {
        this.bc.showMessage(this.messageSub, '未找到挂靠协议图片', 'error');
      }
    });
  }

  // 查看车辆挂靠协议
  checkAffiliationAgreement() {
    if (!this.localTruckDetail['agreementPhoto']) {
        this.bc.showMessage(this.messageSub, '未找到挂靠协议信息', 'error');
        return;
    }
    
    const photoFiles = this.localTruckDetail['agreementPhoto'].split(',');
    const promises = photoFiles.map(fileName => {
        return this.ossFileService.viewOSSFile(this.regExUtils.AFFILIATION_AGREEMENT, fileName, 2).then(res => {
            if (res && res['data'] && res['data']['url']) {
                return res['data']['url'];
            }
            return null;
        }).catch(err => {
            console.error('加载挂靠协议图片失败:', err);
            return null;
        });
    });

    Promise.all(promises).then(urls => {
        const validUrls: string[] = urls.filter(url => url !== null) as string[];
        if (validUrls.length > 0) {
            this.imagePreviewService.preview(validUrls);
        } else {
            this.bc.showMessage(this.messageSub, '获取挂靠协议图片失败', 'error');
        }
    });
  }

    // 预览右侧缩略图
    previewThumbnailImage() {
        var img = document.querySelector('.img-preview-img').getAttribute("src")
        let show_photo_list = [];
        let index = 0;
        for (var i = 0; i < this.thumbnailImageSrc.length; i++) {
            let e = this.thumbnailImageSrc[i];
            if (e['url'] == img) {
                index = i;
            }
            show_photo_list.push(e['url']);
        }
        this.imagePreviewService.preview(show_photo_list, index);
    }



  previewThumbnailImages(photo) {
    var img = photo
    let show_photo_list = [];
    let index = 0;

    for (var i = 0; i < this.departPhotos.length; i++) {
      let e = this.departPhotos[i];
      if (e== img) {
        index = i;
      }
      show_photo_list.push(e);
    }
    this.imagePreviewService.preview(show_photo_list, index);
  }

}



@NgModule({
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule,
        RadioButtonModule, SelectButtonModule, ButtonModule,
         InputTextareaModule, PDetailSidebarModule, ChartModule, KnobModule,
          SkeletonModule, AccordionModule, ChipModule,DialogModule
        ],
    exports: [TruckDetailComponent],
    declarations: [TruckDetailComponent]
})
export class TruckDetailModule { }
